import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { postDataAPI } from '../utils/fetchData';
import { useDispatch } from 'react-redux';
import { setErrorAlert, setSuccessAlert } from '../store/alert/alertSlice';

const GmailCallback = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const code = searchParams.get('code');
        const state = searchParams.get('state');
        const error = searchParams.get('error');

        if (error) {
          dispatch(setErrorAlert(`Gmail authorization failed: ${error}`));
          navigate('/email');
          return;
        }

        if (!code || !state) {
          dispatch(setErrorAlert('Missing authorization parameters'));
          navigate('/email');
          return;
        }
        
        // Exchange code for access token
        const token = JSON.parse(localStorage.getItem('dizeeToken'));
        const response = await postDataAPI('user/gmail/exchange-code', {
          code,
          state
        }, token);
        
        if (response.data.status === 200) {
          dispatch(setSuccessAlert('Gmail connected successfully!'));
            navigate('/email');
        } else {
          throw new Error(response.data?.message || 'Failed to complete Gmail authentication');
        }

      } catch (err) {
        console.error('Error handling Gmail callback:', err);
        dispatch(setErrorAlert(err.message || 'Failed to complete Gmail authentication'));
        navigate('/email');
      }
    };

    handleCallback();
  }, [searchParams, navigate, dispatch]);

  // Return null - no UI needed, just handle callback and redirect
  return null;
};

export default GmailCallback; 